
export default function SocialButtons() {
  return (
    <div className="flex items-center justify-center gap-3">
      <button
        disabled
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white shadow-sm hover:bg-gray-50"
        aria-label="Continue with Google"
      >
        <img
          alt="Google"
          className="h-5 w-5"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
        />
      </button>
      <button
        disabled
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white shadow-sm hover:bg-gray-50"
        aria-label="Continue with Facebook"
      >
        <img
          alt="Facebook"
          className="h-5 w-5"
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg"
        />
      </button>
      <button
        disabled
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white shadow-sm hover:bg-gray-50"
        aria-label="Continue with Apple"
      >
        <img
          alt="Apple"
          className="h-5 w-5"
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/apple.svg"
        />
      </button>
    </div>
  );
}
